module.exports = __webpack_public_path__ + "img/luntan_2018_08.99f663ca.jpg";